import { useUserStore } from '@/stores';

export type ResourcesFontSize = 'xs' | 'sm' | 'base' | 'lg';

export const RESOURCES_FONT_SIZE_OPTIONS: { value: ResourcesFontSize; label: string; size: string }[] = [
  { value: 'xs', label: 'Extra Small', size: '12px' },
  { value: 'sm', label: 'Small', size: '14px' },
  { value: 'base', label: 'Medium', size: '16px' },
  { value: 'lg', label: 'Large', size: '18px' },
];

export function useResourcesFontSize() {
  const resourcesFontSize = useUserStore(state =>
    (state.userSettings.resourcesFontSize as ResourcesFontSize) || 'sm'
  );
  const updateUserSettings = useUserStore(state => state.updateUserSettings);

  const setResourcesFontSize = (value: ResourcesFontSize) => {
    updateUserSettings('resourcesFontSize', value);
  };

  const getFontSizeStyle = (): React.CSSProperties => {
    const option = RESOURCES_FONT_SIZE_OPTIONS.find(o => o.value === resourcesFontSize);
    return { fontSize: option?.size || '14px' };
  };

  return { resourcesFontSize, setResourcesFontSize, getFontSizeStyle };
}
